import React from 'react';
import { DownloadIcon, SearchIcon, TagIcon } from 'lucide-react';
const steps = [{
  icon: DownloadIcon,
  title: '1. Regístrate Gratis',
  description: 'Descarga la App o regístrate en la web en menos de 2 minutos. Solo necesitas tu email.'
}, {
  icon: SearchIcon,
  title: '2. Encuentra tu Comercio',
  description: 'Explora el mapa o el buscador para encontrar promociones cerca de ti.'
}, {
  icon: TagIcon,
  title: '3. Obtén tu Descuento',
  description: 'Presenta tu tarjeta virtual o física al pagar y verás el descuento aplicado al instante.'
}];
interface HowItWorksProps {
  openModal: () => void;
}
export function HowItWorks({
  openModal
}: HowItWorksProps) {
  return <section id="como-funciona" className="py-20 bg-white" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-184">
            Empezar es muy fácil
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-185">
            Sin trámites largos ni esperas. Empieza a disfrutar de los
            beneficios hoy mismo.
          </p>
        </div>

        <div className="relative" data-id="element-186">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gray-100 -z-10" data-id="element-187"></div>

          <div className="grid md:grid-cols-3 gap-12 text-center" data-id="element-188">
            {steps.map((step, index) => <div key={index} className="relative" data-id="element-189">
                <div className="w-24 h-24 bg-white border-4 border-emerald-50 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm z-10" data-id="element-190">
                  <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center text-white" data-id="element-191">
                    <step.icon className="h-8 w-8" data-id="element-192" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-193">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed max-w-xs mx-auto" data-id="element-194">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>

        <div className="mt-16 bg-emerald-900 rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-195">
          <div className="absolute top-0 left-0 w-full h-full opacity-10" data-id="element-196">
            <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-197">
              <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" data-id="element-198" />
            </svg>
          </div>

          <div className="relative z-10 max-w-2xl mx-auto" data-id="element-199">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-200">
              ¿Listo para dejar de pagar de más?
            </h3>
            <p className="text-emerald-100 mb-8 text-lg" data-id="element-201">
              Únete a los miles de usuarios que ya ahorran todos los días con
              ClubAhorra.
            </p>
            <button onClick={openModal} className="bg-white text-emerald-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-emerald-50 transition-colors shadow-lg" data-id="element-202">
              Crear cuenta gratis
            </button>
          </div>
        </div>
      </div>
    </section>;
}